import axios from 'axios';
import Url from '../constants/Url';
import {convertJsonToFormData} from '../utils/Utils';

class SettingsApi {
    getAffiliateSlugOptions() {
        return axios
            .get(Url().GET_AFFILIATE_SLUG_OPTIONS)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getAffiliateSlugOptions:', ex.message);
                throw ex;
            });
    }

    getInfluencerProfile() {
        return axios
            .get(Url().GET_INFLUENCER_PROFILE)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getInfluencerProfile:', ex.message);
                throw ex;
            });
    }

    getOrganizations() {
        return axios
            .get(Url().GET_ORGANIZATIONS)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to get organization', ex.message);
                throw ex;
            });
    }

    getTaxInterviewURL(data) {
        return axios
            .post(Url().GET_TAX_INTERVIEW, data)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get tax interview', ex.message);
                throw ex;
            });
    }

    getTaxRecord() {
        return axios
            .get(Url().GET_TAX_RECORD)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get tax record', ex.message);
                throw ex;
            });
    }

    getBalancePayable() {
        return axios
            .get(Url().GET_BALANCE_PAYABLE)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get balance payable', ex.message);
                throw ex;
            });
    }

    updateAffiliateProfile(data) {
        return axios
            .post(Url().UPDATE_INFLUENCER_PROFILE, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to updateAffiliateProfile:', ex.message);
                throw ex;
            });
    }

    getTaxInfo() {
        return axios
            .get(Url().GET_TAX_INFO)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getTaxInfo:', ex.message);
                throw ex;
            });
    }

    updateTaxInfo(data) {
        return axios
            .post(Url().UPDATE_TAX_INFO, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to updateTaxInfo:', ex.message);
                throw ex;
            });
    }

    getPayoutAccount() {
        return axios
            .get(Url().GET_PAYOUT_ACCOUNT)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getPayoutAccount:', ex.message);
                throw ex;
            });
    }

    updatePayoutAccount(data) {
        return axios
            .post(Url().UPDATE_PAYOUT_ACCOUNT, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to updateTaxInfo:', ex.message);
                throw ex;
            });
    }

    checkW9Form() {
        return axios
            .get(Url().CHECK_W9FORM)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to checkW9Form:', ex.message);
                throw ex;
            });
    }

    uploadW9Form(data) {
        return axios
            .post(Url().UPLOAD_W9FORM, convertJsonToFormData(data), {
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to create influencer profile:', ex.message);
                throw ex;
            });
    }

    retakeInterview(data) {
        return axios
            .post(Url().RETAKE_INTERVIEW, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to retakeInterview:', ex.message);
                throw ex;
            });
    }

    updateTaxRecord(data) {
        return axios
            .post(Url().UPDATE_TAX_RECORD, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to updateTaxRecord:', ex.message);
                throw ex;
            });
    }
}

export default new SettingsApi();
